module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/index-8.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/index.md
// module id = 113
// module chunks = 0